import { FC, useEffect } from "react";

import { useBidderOtpFlow } from "./useBidderOtpFlow";

interface BidderOtpControllerProps {
  onReady: (requireBidderOtp: () => void) => void;
}

export const BidderOtpController: FC<BidderOtpControllerProps> = ({ onReady }) => {
  const { requireBidderOtp, dialog } = useBidderOtpFlow();

  useEffect(() => {
    onReady(requireBidderOtp);
  }, [onReady, requireBidderOtp]);

  return dialog;
};
